export enum JobBoardType {
  Manual = 'manual',
  Auto = 'auto',
}
